import {observer} from 'mobx-react';
import {FormattedMessage} from 'react-intl';
import PayRateTable from './PayRateTable';
import EmployeeTable from './EmployeeTable';
import TaxPropertiesTable from './TaxPropertiesTable';
import SyncedHoursTable from './SyncedHoursTable';
import ExpenseRequestTable from './ExpenseRequestTable';

const DefaultUpdate = observer(({nmbrUpdate}) => {
  const {hasNonRetroactiveFieldUpdates, hasRetroactiveFieldUpdates} = nmbrUpdate;

  if (!hasNonRetroactiveFieldUpdates && hasRetroactiveFieldUpdates) return null;

  if (!hasNonRetroactiveFieldUpdates) {
    return <div className='jumbo'><FormattedMessage id='nmbr.updates.directory.No change'/></div>;
  }

  return (
    <div className='space-y-2'>
      <EmployeeTable nmbrUpdate={nmbrUpdate}/>
      <PayRateTable nmbrUpdate={nmbrUpdate}/>
      <TaxPropertiesTable nmbrUpdate={nmbrUpdate}/>
      <SyncedHoursTable nmbrUpdate={nmbrUpdate}/>
      <ExpenseRequestTable nmbrUpdate={nmbrUpdate}/>
    </div>
  );
});

export default DefaultUpdate;
